module.exports = __webpack_public_path__ + "static/images/components/BuildingCardImage/images/arrow/arrow-3-100.83396274.png";


//////////////////
// WEBPACK FOOTER
// ./components/BuildingCardImage/images/arrow/arrow-3-100.png
// module id = 2556
// module chunks = 11